import { Size, Variant } from './interfaces';
import styles from './SimpleInput.module.scss';

export const VARIANT: Record<Variant, Variant> = {
  primary: 'primary',
};

export const SIZE: Record<Size, Size> = {
  S: 'S',
  M: 'M',
  L: 'L',
};

export const VariantMap = new Map<Variant, string | undefined>([
  [VARIANT.primary, styles.primary],
]);

export const SizeMap = new Map([
  [SIZE.S, styles.sizeS],
  [SIZE.M, styles.sizeM],
  [SIZE.L, styles.sizeL],
]);
